import React, { FunctionComponent } from "react";
import { useIntl } from "react-intl";

import {
  Box,
  Flex,
  Stat,
  StatLabel,
  useColorModeValue,
} from "@chakra-ui/react";

import ConverterState from "./ConverterState";
// import { EConverterState } from "graphql/generated";
import { displayId } from "common/stringUtils"

interface IProps {
  name: string;
  state?: number;
  isSelected: boolean;
  onClick: () => void;
}

const ConverterPreview: FunctionComponent<IProps> = ({
  name,
  state,
  isSelected,
  onClick,
}) => {
  const intl = useIntl();

  return (
    <Stat
      w="full"
      px={{ base: 2, md: 4 }}
      py={"5"}
      shadow={"xl"}
      border={"8px solid"}
      cursor="pointer"
      borderColor={useColorModeValue(
        isSelected ? "enposol.500" : "gray.400",
        isSelected ? "enposol.500" : "gray.600"
      )}
      rounded={"lg"}
      onClick={onClick}
    >
      <Flex justify={"space-between"} align={"center"}>
        <Box>
          <StatLabel fontWeight={"medium"} isTruncated>
            {intl.formatMessage({
              id: "converter___title",
              defaultMessage: "Converter {id}",
            }, {
              id: displayId(name),
            })}
          </StatLabel>
        </Box>
        <ConverterState state={state} />
      </Flex>
    </Stat>
  );
};

export default ConverterPreview;
